import { utcToZonedTime } from 'date-fns-tz'
import { getNeededDateFormat } from '../../../../helper'
import { getTimeZoneByCountryCode } from '../../../../helper/getTimeZone'

export const getFormattedCreatedDate = (date, companyCountryCode) => {
	const dateInUtc = date + 'Z'
	const companyTimeZone = getTimeZoneByCountryCode(companyCountryCode) || 'Europe/Berlin'
	const dateTimeZone = utcToZonedTime(dateInUtc, companyTimeZone)
	return getNeededDateFormat(dateTimeZone, 'HH:mm')
}
